<template>
  <div>
    <div class="account-sidebar-mobile mt-4 pt-5" v-if="isMobileOrTablet">
      <h4 class="font-weight-bold m-0">My Account</h4>
      <ul
        class="nav d-flex flex-column pl-2"
        style="flex-wrap:nowrap; overflow-x: scroll;"
      >
        <li class="p-1 my-1">
          <router-link class="" :to="{ name: 'AccountHistory' }">
            <!-- <font-awesome-icon class="mr-2" icon="clipboard-list" transform="shrink-1"/> -->
            Account History
          </router-link>
        </li>
        <li class="p-1 my-1">
          <router-link class="" :to="{ name: 'AccountInformation' }">
            <!-- <font-awesome-icon class="mr-1" icon="users" transform="shrink-1"/> -->
            Information & Password
          </router-link>
        </li>
        <li class="p-1 my-1">
          <router-link class="" :to="{ name: 'OrderTracking' }">
            <!-- <font-awesome-icon class="mr-1" icon="tag" transform="shrink-1"/> -->
            Customer Service / Tracking
          </router-link>
        </li>
      </ul>
    </div>
    <div class="account-sidebar dark-bg" v-else>
      <h4 class>My account</h4>
      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'AccountHistory' }">
            <font-awesome-icon
              class="mr-2"
              icon="clipboard-list"
              transform="shrink-1"
            />
            Account history
            <span class="sr-only">(current)</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'AccountInformation' }">
            <font-awesome-icon class="mr-1" icon="users" transform="shrink-1" />
            Information & Password
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'OrderTracking' }">
            <font-awesome-icon class="mr-1" icon="tag" transform="shrink-1" />
            Customer Service / Tracking
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { isMobile, isTablet } from "mobile-device-detect";

export default {
  computed: {
    isMobileOrTablet: function() {
      return isMobile || isTablet;
    },
  },
};
</script>

<style lang="scss" scoped>
.account-sidebar-mobile {
  color: $white;
  padding: 24px 0px;
  font-weight: 700;
  h4 {
    padding: 12px 32px;
    &::after {
      display: none;
    }
  }
  a {
    padding: 10px 36px;
    background-color: rgb(199, 199, 199);
    white-space: nowrap;
    border-radius: 50px;
    color: black;
    &:hover {
      background-color: transparentize($primary, 0.7%);
    }
  }
  .router-link-active {
    background-color: rgb(7, 7, 41);
    color: white;
  }
}
.account-sidebar{
  background-color: $gray-900;
  color: $white;
  height: 90vh;
  padding: 24px 0px;
  font-weight: 700;
  h4{
    padding: 12px 32px;
    &::after{
      display: none;
    }
  }
  a{
    padding: 18px 36px;
    color: $white;
    &:hover{
      background-color: transparentize($primary, 0.7%);
    }
  }
  .router-link-active{
    background-color: $primary;
  }
}
</style>
